var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useRef } from 'react';
import { ArrowDown, Attachment, Close, Flow } from '../../shared/icons/icons';
import { Loading } from '../../styled/Basic';
import { appColors } from '../../styled/useTheme';
export function Attachemnt(props) {
    var id = props.id, name = props.name, _a = props.loading, loading = _a === void 0 ? false : _a, onDownload = props.onDownload, onRemove = props.onRemove;
    return (React.createElement("span", { style: {
            height: 24,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: 4,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: appColors.neutral.w200,
            borderRadius: 4,
            backgroundColor: appColors.neutral.w100,
            marginRight: 10,
            flexShrink: 1,
            marginBottom: 4,
            cursor: loading ? 'progress' : 'default',
        } },
        React.createElement(Flow, { width: 24, height: 24 }),
        React.createElement("span", { style: { whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: 100, overflow: 'hidden' } }, name),
        !loading ? (React.createElement(React.Fragment, null,
            !!onDownload && typeof id === 'string' && (React.createElement(ArrowDown, { cursor: "pointer", width: 24, height: 24, onClick: function () { return onDownload === null || onDownload === void 0 ? void 0 : onDownload(id); } })),
            !!onRemove && typeof id === 'number' && (React.createElement(Close, { cursor: "pointer", width: 24, height: 24, onClick: function () { return onRemove === null || onRemove === void 0 ? void 0 : onRemove(id); } })))) : (React.createElement(Loading, { "$size": 0.8, "$color": appColors.ui.dark, style: { position: 'relative' } }))));
}
export function AttachmentInput(props) {
    var fileInputRef = useRef(null);
    return (React.createElement("span", { style: {
            marginLeft: 8,
            display: 'grid',
            position: 'relative',
            placeItems: 'center',
            alignSelf: 'end',
        } },
        React.createElement(Attachment, { onClick: function () { var _a; return (_a = fileInputRef === null || fileInputRef === void 0 ? void 0 : fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, cursor: "pointer" }),
        React.createElement("input", __assign({ multiple: true, type: "file", id: "attachments", name: "attachments", ref: fileInputRef, style: {
                width: 1,
                height: 1,
                border: 0,
                margin: -1,
                overflow: 'hidden',
                position: 'absolute',
                clip: 'rect(0 0 0 0)',
            } }, props))));
}
